import type { View } from './state/store';

const PATH_VIEWS: Partial<Record<string, View>> = {
  '/how-to-play': 'how-to-play',
  '/docs': 'docs',
  '/roadmap': 'roadmap',
  '/spectate': 'spectate',
  '/waystation': 'waystation',
  '/dashboard': 'dashboard',
  '/run': 'run',
  '/inventory': 'inventory',
  '/merchant': 'merchant',
  '/marketplace': 'marketplace',
  '/cashout': 'cashout',
  '/spinner': 'spinner',
  '/cosmetics': 'cosmetics',
  '/admin': 'admin',
};

export function viewFromPath(pathname: string): View | null {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return PATH_VIEWS[normalized] ?? null;
}
